<template>
  <v-icon
    :color="getColor"
    dark
    right
    v-on="$listeners"
  >
    {{ getIcon }}
  </v-icon>
</template>

<script>
export default {
  name: "TrueFalseIcon",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getColor() {
      return this.value ? "green" : "red";
    },
    getIcon() {
      return this.value ? "mdi-checkbox-marked-circle" : "mdi-cancel";
    }
  }
}
</script>

<style scoped>

</style>
